import { render, staticRenderFns } from "./teachergroups.vue?vue&type=template&id=4b9e5f34"
import script from "./teachergroups.ts?vue&type=script&lang=js&external"
export * from "./teachergroups.ts?vue&type=script&lang=js&external"
import style0 from "./teachergroups.vue?vue&type=style&index=0&id=4b9e5f34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports